// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"199":"22865083","488":"c2b8bcfc","840":"f1029559"}[chunkId] + ".chunk.js";
};